import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../common/Footer";
import Navbar from "../common/Navbar";
import WhatsappBusinessApi from "../components/service/WhatsappBusinessApi";
import { Helmet } from "react-helmet";

const WhatsappBusiness = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, [location.pathname]);

  console.log("locationioio", location)

  return (
    <>
      <Helmet>
        <title>WhatsApp Business API for Scalable Messaging</title>
        <meta
          name="description"
          content="Automate customer communication with WhatsApp Business API. Send notifications, alerts, and campaigns securely. Get started today!"
        />
      </Helmet>

      <div>
        <Navbar />
        <WhatsappBusinessApi />
        <Footer />
      </div>
    </>
  );
};

export default WhatsappBusiness;
